<template>
  <div id="order-cart-vue-scoped-css">
    <el-container class="root_container" style="min-height: 800px">
      <el-header style="min-height: 36px; overflow: hidden; height: 38px">
        <vHead></vHead>
      </el-header>
      <keep-alive>
        <el-header style="height: 100px"><vNav></vNav></el-header>
      </keep-alive>
      <el-main style="min-width: 1200px; flex: none">
        <div
          class=""
          style="
            display: flex;
            width: 1190px;
            margin: 0 auto;
            justify-content: space-between;
            padding-top: 33px;
            padding-bottom: 20px;
          "
        >
          <div>
            <span
              style="
                height: 40px;
                font-size: 24px;
                margin-top: 5px;
                font-family: MicrosoftYaHei;
                color: #262626;
                line-height: 40px;
              "
              >购物袋</span
            >
          </div>
          <vProcess :step="step" :titleArr="titleArr"></vProcess>
        </div>
      </el-main>
      <div style="width: 1200px; margin: 0px auto">
        <vCard style="background:#f5f5f5 !important">
          <div ref="div1">
            <el-table
              ref="multipleTable"
              :data="cities"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              @selection-change="handleCheckAllChange"
            >
              <el-table-column 
                type="selection" 
                width="55"
              > </el-table-column>

              <el-table-column prop="name" label="商品信息" width="390">
                <template slot-scope="scope">
                  <div class="ts">
                    <div style="position:relative;">
                      <div class="imgmask" v-show="scope.row.status == 0">
                        <div class="no-product">已下架</div>
                      </div>
                      <div class="img-box" style="display: inline-block">
                        <router-link
                          tag="a"
                          target="_blank"
                          :to="{
                            name: 'Detail',
                            params: { id: scope.row.goods_id }
                          }"
                          style="padding-bottom: 5px"
                        >
                          <img
                            v-lazy="scope.row.image"
                            :src="scope.row.image"
                            style="max-height: 80px; max-width: 80px"
                            onerror="src='/static/imgout1.png'"
                          />
                        </router-link>
                      </div>
                    </div>

                    <div style="padding-left:40px;">
                      <div style="text-align:left;">
                        <span class="jd" v-show="scope.row.source == 1"
                          >优选</span
                        >
                        <span class="yx" v-show="scope.row.source == 6"
                          >严选</span
                        >
                        <span class="new" v-show="scope.row.source == 2"
                          >直充</span
                        >
                        <span class="rob" v-show="scope.row.source == 3"
                          >卡券</span
                        >
                        {{ scope.row.name }}
                      </div>
                      <div 
                        v-if="$store.state.mallStockShow"
                        style="text-align:left; margin-top: 10px;font-size: 12px;color: #989898; margin-right: 10px;"
                      >
                        <span v-if="scope.row.stock_status === 1">库存：{{ scope.row.stock_number }}</span>
                        <span 
                          v-if="scope.row.stock_member_status === 1"
                        >剩余兑换数：{{ scope.row.stock_member_number - scope.row.stock_member_count < 0 ? 0 : scope.row.stock_member_number - scope.row.stock_member_count }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="单价">
                <template slot-scope="scope">
                  <span v-if="scope.row.point"
                    >{{ scope.row.point }} {{ $store.state.name }}</span
                  >
                  <span v-if="scope.row.cash && scope.row.cash != 0">
                    <span v-if="scope.row.point">+</span>{{ scope.row.cash }}元
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                  <vInputNumber
                    :max="999"
                    :min="1"
                    v-model="scope.row.number"
                    v-if="hardReset"
                    @change="
                      addcart(scope.row.cart_id, scope.row.number, index)
                    "
                  ></vInputNumber>
                </template>
              </el-table-column>
              <el-table-column label="小计">
                <template slot-scope="scope">
                  <span>
                    <span v-if="scope.row.point">
                      {{ scope.row.number * scope.row.point }}
                      {{ $store.state.name }}
                    </span>
                    <span v-if="scope.row.cash && scope.row.cash != 0">
                      <span v-if="scope.row.point">+</span
                      >{{ scope.row.number * scope.row.cash }}元
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="remover(scope.row.cart_id)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            class="submit-box "
            :class="fixed ? 'box-fixed' : 'submit-box1'"
            v-if="cities.length != 0"
          >
            <div style="background:#fff;width:100%;    height: 100%;">
              <p
                class="float-left"
                style="margin-left: 18px; line-height: 62px;background:#fff;"
              >
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange1()"
                  >全选</el-checkbox
                >
                <span @click="Batchremove">批量删除</span>
              </p>
              <div
                class="theme-bg submit-btn"
                style="background:#fff;"
                @click="submitb()"
              >
                确认提交
              </div>
              <div
                style="height: 60px;
                  line-height: 50px;
                  margin-left:20px;
                  padding:0px;
                  background:#fff;
                "
              >
                合计：
                <span
                  class="theme-col"
                  style="font-size: 30px"
                  v-if="totalprices || !totalcash"
                >
                  {{ totalprices
                  }}<span class="theme-col" style="font-size: 14px">{{
                    $store.state.name
                  }}</span>
                </span>
                <span v-if="totalcash">
                  <span class="theme-col" style="font-size: 30px">
                    <span v-if="totalprices">+</span>{{ totalcash }}</span
                  ><span class="theme-col">元</span>
                </span>
              </div>
              <div style="line-height: 62px;background:#fff;">
                共
                <span class="theme-col" style="font-size: 16px">{{
                  checkedCities.length
                }}</span>
                件商品
              </div>
            </div>
          </div>
        </vCard>
      </div>
    </el-container>
    <el-footer
      style=" background: #ffffff;height:auto;padding:0;border-top:solid 1px #e5e5e5;"
    >
      <vFooter></vFooter>
    </el-footer>
  </div>
</template>

<script>
import vHead from "@/common/header";
import vNav from "@/common/nav";
import vSearch from "@/common/search";
import vProcess from "@/common/process";
import vCard from "@/common/card";
import vFooter from "@/common/footer";
import vInputNumber from "@/common/inputnumber";
// const goodsOptions = [1,2,3];
export default {
  name: "exchange",
  data() {
    return {
      isIndeterminate: false, //控制不完整的全选状态
      hardReset: true, //控制全选状态
      step: 1,
      titleArr: ["选择商品", "确认订单", "成功提交订单"],
      checkAll: false,
      checkedCities: [],
      cities: [],
      totalprices: 0,
      totalcash: 0,
      id_cart: [], //
      boxHeight: 0,
      fixed: true
    };
  },
  components: {
    vHead,
    vSearch,
    vProcess,
    vCard,
    vFooter,
    vInputNumber,
    vNav,
    vInputNumber
  },
  watch: {
    checkedCities: {
      deep: true,
      handler: function(newVal, oldVal) {
        var _this = this;
        this.totalprices = 0;
        this.totalcash = 0;
        $.each(this.checkedCities, function(index, items) {
          _this.totalprices += items.number * items.point;
          _this.totalcash += items.number * items.cash;
        });
      }
    }
    //  boxHeight(){
    //      console.log(this.$refs.multipleTable);
    //      return this.$refs.multipleTable;
    //   }
    //   boxHeight(){
    //    console.log(this.$refs['div1'].style.height);
    //    return this.$refs.div1;
    // }
  },
  computed: {
    // boxHeight(){
    //    console.log(this.$refs.div1.offsetHeight);
    //    return this.$refs.div1;
    // }
  },
  methods: {
    handeScroll() {
      //  console.log(this.$refs.div1.offsetTop)
      let scrollTop =
        window.pageYOfffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log(scrollTop);
      if (scrollTop > this.boxHeight + 231 - window.innerHeight) {
        this.fixed = false;
      } else {
        this.fixed = true;
      }
    },
    //表格底部全选
    handleCheckAllChange1() {
      if (this.$refs.multipleTable.selection.length < this.cities.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 表格全选
    handleCheckAllChange(val) {
      console.log(val);
      this.checkedCities = val;
      var _this = this;
      this.totalprices = 0;
      this.totalcash = 0;
      this.checkedCities.forEach(item => {
        this.totalprices += item.number * item.point;
        this.totalcash += item.number * item.cash;
      });

      if (val.length < this.cities.length && val.length > 0) {
        this.isIndeterminate = true;
      } else if (val.length == this.cities.length) {
        this.isIndeterminate = false;
        this.checkAll = true;
      } else if (val.length == 0) {
        this.isIndeterminate = false;
        this.checkAll = false;
      }
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      var _this = this;
      this.totalprices = 0;
      this.totalcash = 0;
      $.each(this.checkedCities, function(index, items) {
        _this.totalprices += items.number * items.point;
        this.totalcash += item.number * item.cash;
      });
    },
    getDota() {
      this.cities = [];
      this.$api.get(
        "user/cart/list",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id
        },
        res => {
          if (res.data.code == 100) {
            if (res.data.data.length != 0) {
              this.cities = res.data.data;
              console.log(this.cities);
              this.$nextTick(() => {
                this.boxHeight = this.$refs.div1.offsetHeight;
                console.log(this.$refs.div1.offsetHeight);
                console.log(this.$refs.div1.offsetTop);
                if (this.boxHeight + 231 > window.innerHeight) {
                  this.fixed = true;
                  console.log(12);
                } else {
                  this.fixed = false;
                  console.log(123);
                }
              });
            }
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    //提交订单
    submitb() {
      var _this = this;
      this.id_cart = [];
      if (this.checkedCities.length == 0) {
        this.$alert("请选择要购买的商品", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      $.each(this.checkedCities, function(index, items) {
        if(items.stock_member_status === 1 && items.stock_member_number - (items.stock_member_count + items.number) < 0 && _this.$store.state.mallStockShow) {
          _this.$alert(items.name + "剩余可兑换数超出限制", "提示", {
            confirmButtonText: "确定",
            callback: action => {

            }
          });
        } else {
          _this.id_cart.push(items.cart_id);
        }
      });
      if(this.id_cart.length !== this.checkedCities.length) {
        return
      }
      var str = this.id_cart;
      str = str.join(",");
      this.$api.get(
        "order/cart/create",
        // "order/externalCart/create",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          terminal: "pc",
          id_cart: str
        },
        res => {
          if (res.data.code == 100) {
            this.$router.push({
              name: "AffirmOrder",
              params: { id_cfir: res.data.data.id_cfir }
            });
          } else if (res.data.code == "-200") {
            this.$confirm("积分不足请兑换积分", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.$router.push({
                  name: "Buypoints",
                  params: { points: res.data.message }
                });
              })
              .catch(() => {});
          } else {
            this.$alert(
              this.$common.cardName().type ? "余额不足" : res.data.message,
              "提示",
              {
                confirmButtonText: "确定",
                callback: action => {}
              }
            );
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    //批量删除
    Batchremove() {
      // var id=[]
      var _this = this;
      // $.each(this.checkedCities, function(index, items) {
      //       id.push(items.cart_id)
      //     })
      // this.remover(id.join(','))
      this.checkedCities.forEach(function(val, index) {
        _this.remover(val.cart_id);
      });
    },
    //删除
    remover(id) {
      this.$api.get(
        "user/cart/delete",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          cart_id: id
        },
        res => {
          if (res.data.code == 100) {
            var _this = this;
            // $.each(this.cities, function(index, items) {
            //   items.cart_id==id?_this.cities.remove(index-1):''
            // })
            this.cities.forEach(function(val, index) {
              if (val.cart_id == id) {
                _this.cities.splice(index, 1);
              }
            });
            this.checkedCities.forEach(function(val, index) {
              if (val.cart_id == id) {
                _this.checkedCities.splice(index, 1);
              }
            });
            //this.checkedCities
            //this.getDota()
            this.$store.commit("cartnum");
          }
        }
      );
    },
    //改变商品数量
    addcart(id, nums, index) {
      if (nums >= 999) {
        this.hardReset = false;
        this.$nextTick(() => {
          this.hardReset = true;
        });
      }
      this.$api.get(
        "user/cart/product",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_cart: id,
          number: nums
        },
        res => {}
      );
    }
  },

  mounted() {
    this.getDota();
    console.log(this.$refs.div1.offsetHeight);
    console.log(window.innerHeight);
  },
  created() {
    window.addEventListener("scroll", this.handeScroll);
  }
};
</script>

<style lang="less" scoped>
.box-fixed {
  position: fixed;
  width: 1200px;
  left: 50%;
  margin-left: -600px !important;
  bottom: 0;
  z-index: 20;
  background-color: #fff;
  box-shadow: 0px -3px 20px 0px rgba(132, 132, 132, 0.1);
}
/deep/ .el-button--text {
  color: #272727;
  &:hover {
    color: #272727 !important;
    border: none;
  }
}
/deep/ .el-checkbox__inner {
  border-radius: 3px;
}
/deep/ .el-table .cell {
  font-weight: 400;
}
.ts {
  display: flex;
}
.root_container {
  margin-bottom: 50px;
}
.row {
  height: 143px;
  line-height: 143px;
  clear: both;
}
.row > li {
  box-sizing: border-box;
  float: left;
  &:nth-child(1) {
    font-weight: bold;
    font-size: 16px;
    width: 15%;
    text-align: left;
  }
  &:nth-child(2) {
    width: 25%;
  }
  &:nth-child(3) {
    width: 15%;
  }
  &:nth-child(4) {
    width: 15%;
  }
  &:nth-child(5) {
    width: 15%;
  }
  &:nth-child(6) {
    width: 15%;
  }
}
.goods-list > .row > li {
  &:nth-child(1) {
    height: 143px;
  }
}
.goods {
  float: left;
  border-bottom: 1px dashed #dfdfdf;
}
.goods:last-child {
  border: none;
}
.check {
  width: 20px;
  height: 20px;
  display: inline-block;
  /*position: absolute;*/
  /*top: calc(50% - 10px);*/
  box-sizing: border-box;
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
  display: inline-block;
  line-height: unset;
  // margin-top: 17px;
  img {
    // position: absolute;
    // top: 50%;
    // left: calc(50% + 28px);
    // transform: translate(-50%, -50%);
  }
}

.submit-box {
  width: 1200px;
  margin: 0 auto;

  height: 62px;
  // margin-top: 30px;
  background-color: #fff;
  .submit-btn {
    width: 180px;
    font-size: 16px;
    text-align: center;
    height: 60px;
    line-height: 60px;
  }
  & > div > div {
    float: right;
  }

  & > div > div:nth-child(2) {
    cursor: pointer;
  }
  & > div > div:nth-child(3) {
    margin-right: 27px;
    padding: 15px 0px 19px 20px;
  }
}
.submit-box1 {
  padding-top: 40px !important;
  background: #f5f5f5;
}
.nocart {
  margin: 80px auto;
  width: 180px;
  padding-bottom: 50px;
  img {
    width: 145px;
  }
  p {
    margin: 20px 0;
  }
  a {
    display: inline-block;
    width: 140px;
    text-align: center;
    line-height: 35px;
    border-radius: 50px;
  }
}
.imgmask {
  width: 110px;
  height: 110px;
  position: absolute;

  background: #333;
  z-index: 99;
  opacity: 0.5;
  width: 52px;
  height: 52px;
  top: 50%;
  border-radius: 50%;
  background: rgba(38, 38, 38, 0.5);
  top: 50%;
  margin-left: -26px;
  left: 50%;
  margin-top: -26px;
}
.no-product {
  width: 46px;
  height: 46px;
  line-height: 46px;
  font-size: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  border-radius: 46px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/affirmOrder/cart.vue